module.exports = __webpack_public_path__ + "src/img/upload.8ae08e25.svg";